export default __webpack_public_path__ + "static/media/resume.ffca770e.pdf";